export default __webpack_public_path__ + "static/media/Moooi-Logo.f8641980.png";